module.exports = __webpack_public_path__ + "static/1741811.b08acb94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/welcome-block/1741811.jpg
// module id = 124
// module chunks = 35783957827783 122595392396565